__turbopack_context__.v({
  "__four": "AboutForma-module-scss-module__WN3OuG____four",
  "__one": "AboutForma-module-scss-module__WN3OuG____one",
  "__three": "AboutForma-module-scss-module__WN3OuG____three",
  "__two": "AboutForma-module-scss-module__WN3OuG____two",
  "arrow": "AboutForma-module-scss-module__WN3OuG__arrow",
  "middleImages": "AboutForma-module-scss-module__WN3OuG__middleImages",
  "mobCard": "AboutForma-module-scss-module__WN3OuG__mobCard",
  "mobCards": "AboutForma-module-scss-module__WN3OuG__mobCards",
  "nav": "AboutForma-module-scss-module__WN3OuG__nav",
  "next": "AboutForma-module-scss-module__WN3OuG__next",
  "ninthScreenBox": "AboutForma-module-scss-module__WN3OuG__ninthScreenBox",
  "ninthScreenCardTitle": "AboutForma-module-scss-module__WN3OuG__ninthScreenCardTitle",
  "ninthScreenContainer": "AboutForma-module-scss-module__WN3OuG__ninthScreenContainer",
  "ninthScreenDescription": "AboutForma-module-scss-module__WN3OuG__ninthScreenDescription",
  "ninthScreenGallery": "AboutForma-module-scss-module__WN3OuG__ninthScreenGallery",
  "ninthScreenImagesBox": "AboutForma-module-scss-module__WN3OuG__ninthScreenImagesBox",
  "ninthScreenImg": "AboutForma-module-scss-module__WN3OuG__ninthScreenImg",
  "ninthScreenImgBox": "AboutForma-module-scss-module__WN3OuG__ninthScreenImgBox",
  "ninthScreenImgInner": "AboutForma-module-scss-module__WN3OuG__ninthScreenImgInner",
  "ninthScreenLogo": "AboutForma-module-scss-module__WN3OuG__ninthScreenLogo",
  "ninthScreenTitle": "AboutForma-module-scss-module__WN3OuG__ninthScreenTitle",
  "ninthScreenTitleContainer": "AboutForma-module-scss-module__WN3OuG__ninthScreenTitleContainer",
  "ninthScreenTitleForst": "AboutForma-module-scss-module__WN3OuG__ninthScreenTitleForst",
  "ninthScreenTitlePortland": "AboutForma-module-scss-module__WN3OuG__ninthScreenTitlePortland",
  "ninthScreenTitleRepublic": "AboutForma-module-scss-module__WN3OuG__ninthScreenTitleRepublic",
  "ninthScreenWrapper": "AboutForma-module-scss-module__WN3OuG__ninthScreenWrapper",
  "prev": "AboutForma-module-scss-module__WN3OuG__prev",
  "svgClass": "AboutForma-module-scss-module__WN3OuG__svgClass",
});
